/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CalculateCheckout201ResponseAllOfData } from './CalculateCheckout201ResponseAllOfData';
import {
    CalculateCheckout201ResponseAllOfDataFromJSON,
    CalculateCheckout201ResponseAllOfDataFromJSONTyped,
    CalculateCheckout201ResponseAllOfDataToJSON,
} from './CalculateCheckout201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CalculateCheckout201Response
 */
export interface CalculateCheckout201Response {
    /**
     * 
     * @type {CalculateCheckout201ResponseAllOfData}
     * @memberof CalculateCheckout201Response
     */
    data: CalculateCheckout201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CalculateCheckout201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CalculateCheckout201Response interface.
 */
export function instanceOfCalculateCheckout201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CalculateCheckout201ResponseFromJSON(json: any): CalculateCheckout201Response {
    return CalculateCheckout201ResponseFromJSONTyped(json, false);
}

export function CalculateCheckout201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateCheckout201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CalculateCheckout201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CalculateCheckout201ResponseToJSON(value?: CalculateCheckout201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CalculateCheckout201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

